import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
        <nav className="nav">
          <div className="nav-left">
            <Link to="/" className="logo">
              <img 
                src="https://hzmsjouaorxtdfjrfvrz.supabase.co/storage/v1/object/public/Assets/ChatGPT%20Image%20Nov%203,%202025,%2002_03_49%20PM%20(3).png"
                alt="Nanocaps Logo" 
                className="logo-image"
              />
              <span className="logo-text">Nanocaps</span>
            </Link>
          </div>

          <button 
            className="menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            {menuOpen ? '✕' : '☰'}
          </button>

          <div className={`nav-right ${menuOpen ? 'active' : ''}`}>
            <ul className="nav-links">
              <li><a href="#features">The Engine</a></li>
              <li><Link to="/manifesto">Manifesto</Link></li>
              <li>
                <a href="https://app.nanocaps.ai/signup" className="header-cta-button">
                  <img 
                    src="https://hzmsjouaorxtdfjrfvrz.supabase.co/storage/v1/object/public/Assets/sound.png" 
                    alt="Sound icon" 
                    className="button-icon"
                  />
                  Book a Call
                </a>
              </li>
            </ul>
          </div>
        </nav>
    </header>
  );
};

export default Header;

